import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ResponseModel } from "../models/response.model";
import { GeneralService } from "./general.service";
import { PersistenceService } from "angular-persistence";
import { environment } from "../../environments/environment";
import { HttpParams } from '@angular/common/http';
import { MessageService } from "primeng/components/common/messageservice";
import { HubTransfer } from "../models/hubTransfer.model";
import { StringHelper } from "../infrastructure/string.helper";
import { ResponseOfReportModel } from "../models/abstract/responseOfReportModel.interface";
import { ReportPickupDetail } from "../models/reportPickupDetail.model";
import { ReportDeliveryDetail } from "../models/reportDeliveryDetail.model";
import { ReportDeliveryFail } from "../models/reportDeliveryFail.model";
import { ReportResultBusiness } from "../models/reportResultBusiness.model";
import { ReportKPICustomer } from "../models/reportKPICustomer.model";
import { ReportKPIBusiness } from "../models/reportKPIBusiness.model";
import { ReportLadingScheduleFilter } from "../models/reportLadingScheduleFilter.model";
import { ReportLadingSchedule } from "../models/reportLadingSchedule.model";
import { ReportTruckTransferFilter } from "../models/reportTruckTransferFilter.model";
import { ReportTruckTransfer } from "../models/reportTruckTransfer.model";
import { ReportEmpReceiptIssueFilter } from "../models/reportEmpReceiptIssueFilter.model";
import { ReportEmpReceiptIssue } from "../models/reportEmpReceiptIssue.model";
import { ReportIncidents } from "../models/reportIncidents.model";
import { ReportIncidentsFilter } from "../models/reportIncidentsFilter.model";
import { DashboardFilter } from "../models/dashboardFilter.model";
import { DashboardShipment } from "../models/dashboardPickup.model";
import { DashboardTransfer } from "../models/dashboardTransfer.model";
import { DashboardDelivery } from "../models/dashboardDeliveryAndReturn.model";
import { DashboardService } from "../models/dashboardService.model";
import { ListGoods } from "../models/listGoods.model";
import { ReportByCus } from "../models/reportByCus.model";
import { ReportByCusFilter } from "../models/reportByCusFilter.model";
import { ReportRevenueMonth } from "../models/reportRevenueMonth.model";
import { ReportRevenueYear } from "../models/reportRevenueYear.model";
import { ReportHanldeEmployee } from "../models/reportHanleEmployee.model";
import { ShipmentFilterViewModel } from "../models/shipmentFilterViewModel";
import { ReportCustomerExport } from "../models/ReportCustomerExport.model";
import { ReportPayablesAndReceivablesByCustomerViewModel } from "../models/ReportPayablesAndReceivablesByCustomerViewModel.model";
import { GetReportCancelShipmentExportViewModel } from "../models/GetReportCancelShipmentExportViewModel.model";
import { ReportKPICustomerExport } from "../models/ReportKPICustomerExport.model";
import { GetReportByRevenueMonthViewModel } from "../models/GetReportByRevenueMonthViewModel.model";
import { GetReportByRevenueYearViewModel } from "../models/GetReportByRevenueYearViewModel.model";
import { GetReportPickupDeliveryExportViewModel } from "../models/GetReportPickupDeliveryExportViewModel.model";
import { IReportCustomerNoRevenue } from "../models/abstract/reporrtCustomerNoRevenue.interface";
import { IReportCustomerHaveRevenue } from "../models/abstract/ireportCustomerHaveRevenue.interface";
import { Customer, InvoiceCustomerFilter, ListGoodsFilterViewModel, Shipment } from "../models";
import { ReportCustomerLiabilities } from "../models/ReportCustomerLiabilities";
import { ReportDeliveryEmployee } from "../models/reportDeliveryEmployee";
import { ReportDeliveryEmployeeExport } from "../models/reportDeliveryEmployeeExport";
import { ShipmentWaitAssignPickupExport } from "../models/shipmentWaitAssignPickupExport.model";
import { async } from "rxjs/internal/scheduler/async";
import { ShipmentVersionExport } from "../models/ShipmentVersionExport.model"
import { from } from "rxjs";
import { ReportPromotionShipmentExport } from "../models/reportPromotionShipmentExport.model";
import { ReportPromotionShipmentFilter } from "../models/reportPromotionShipmentFilter.model";
import { ReportPromotionShipment } from "../models/ReportPromotionShipment.model";
import { ReportShipmentAccountantExport } from "../models/reportshipmentAccountantExport.model"
import { ReportListOutWarehouse } from "../models/report-list-out-warehouse.model";
import { ReportShipmentListGoodDelivery } from "../view-model/reportShipmentListGoodDelivery.viewModel";
import { ListGoodTranferUnloadViewModel } from "../models/getListGoodTranferUnload.model";
import { ShipmentContactFilter } from "../models/ShipmentContactFilter.model";
import { PriceServiceFilter } from "../models/abstract/priceServiceFilter.model";
import { DeliveryPaymentEmployee } from "../models/deliveryPaymentEmployee.model";
import { DeliVeryInfoFilter } from "../models/deliVeryInfo.model";
import { ShipmentHistoryDetail } from "../models/shipmentHistoryDetail.model"
import { Debit } from "../models/debit.model";
import { ReceiptMoneyFromRiderExport } from "../models/filterReceiptMoneyFromRiderExport.model";
import { ReportGeneralFilter } from '../models/reportGeneralFilter.model';
import { ReportGeneral } from '../models/reportGeneral.model';
import { TransactionHistoryFilter } from "../models/transactionHistoryFilter.model";
import { HandOverExport } from "../models/handeOverExport.model";
import { DashboardDebitModel } from "../models/dashboardDebit.model";
import { ReportlistShipmentBoxByListGoodId } from "../models/ReportListShipmentBoxByListGoodId.model";
import { IncidentFillter } from "../models/incidentFillter.model";
import { ReportZaloFilter } from "../models/reportZaloFilter.model";
import { ReportPaymentDebitExport } from "../models/reportPaymentDebitExport.model";
import { forEach } from "@angular/router/src/utils/collection";
import { ParkingTicketFilter } from "../models/parkingTicketFilter.model";
import { DashboardMonthlyRevenue } from "../models/dashboardMonthlyRevenue.model";
import { DashboardPriceDebit } from "../models/dashboardPriceDebit.model";

@Injectable()
export class
  ReportService extends GeneralService {
  constructor(
    protected messageService: MessageService,
    protected httpClient: HttpClient,
    protected persistenceService: PersistenceService
  ) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "report");
  }

  //* region Report General
  async getReportGeneral(model: ReportGeneralFilter): Promise<any> {
    var res = await super.postCustomApi("GetReportGeneral", model).toPromise();
    if (!this.isValidResponse(res)) return [];
    return res;
  }

  async getReportGeneralExport(model: ReportGeneralFilter) {
    const res = await super.postCustomApiExcel("GetReportGeneralExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  getReportSumary(fromDate: string = null, toDate: string = null, type?: string, arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined) {
    let params = new HttpParams();
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    params = params.append("type", type);
    return super.getCustomApiPaging("getReportSumary", arrCols, params, pageSize, pageNumber)
  }

  getReportCustomer(type: number = null, customerId: number = null, fromDate: string = null, toDate: string = null, hubId: any) {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("customerId", customerId + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    params = params.append("hubId", hubId);
    return super.getCustomApiPaging("getReportCustomer", [], params, null, null)
  }
  async getReportCustomerNoRevenue(customerId: number = null, fromHubId: number = null, fromDate: string = null, toDate: string = null, pageNum: number = null, pageSize: number = null): Promise<IReportCustomerNoRevenue[]> {
    let params = new HttpParams();
    params = params.append("customerId", customerId + "");
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    params = params.append("pageNum", pageNum + "");
    params = params.append("pageSize", pageSize + "");
    const res = await super.getCustomApi("GetReportCustomerNoRevenue", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async getReportCustomerHaveRevenue(customerId: number = null, poHubFrom: any, fromHubId: number = null, fromDate: string = null, toDate: string = null, pageNum: number = null, pageSize: number = null): Promise<IReportCustomerHaveRevenue[]> {
    let params = new HttpParams();
    params = params.append("customerId", customerId + "");
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("poHubId", poHubFrom + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    params = params.append("pageNum", pageNum + "");
    params = params.append("pageSize", pageSize + "");
    const res = await super.getCustomApi("GetReportCustomerHaveRevenue", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  getReportCreateShipment(model: any) {
    return super.postCustomApi("ReportCreateShipment", model)
  }
  async getListShipmentCreatedByEmployeeId(model: any) {
    const res = await super.postCustomApi("GetListShipmentCreatedByEmployeeId", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async getReportCreateShipmentAsync(model: any) {
    let res = await this.getReportCreateShipment(model).toPromise();
    return res;
  }

  getReportPayablesAndReceivablesByCustomer(type: number = null, customerId: number = null, fromDate: string = null, toDate: string = null, arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined) {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("customerId", customerId + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging("getReportPayablesAndReceivablesByCustomer", arrCols, params, pageSize, pageNumber)
  }

  getReportTransfer(isAllowChild: boolean, hubId: number, fromDate?: string, toDate?: string, arrCols?: string[], pageSize?: number, pageNumber?: number) {
    let params = new HttpParams();
    params = params.append("isAllowChild", isAllowChild + "");
    params = params.append("hubId", hubId + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging("GetReportTransfer", arrCols, params, pageSize, pageNumber);
  }

  async getReportTransferAsync(isAllowChild: boolean, hubId: number, fromDate?: string, toDate?: string, arrCols?: string[], pageSize?: number, pageNumber?: number) {
    const res = await this.getReportTransfer(isAllowChild, hubId, fromDate, toDate, arrCols, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as HubTransfer[];
    return data;
  }
  getReportDeliveryByListGoods(fromDate: any = null, toDate: any = null, arrCols: string[] = [], isAllowChild: boolean = false, hubId: number = null, userId: number = null, pageSize: number = null, pageNumber: number = null) {
    let params = new HttpParams();
    params = params.append("isAllowChild", isAllowChild + "");
    params = params.append("hubId", hubId + "");
    params = params.append("userId", userId + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging("GetReportDeliveryByListGoods", arrCols, params, pageSize, pageNumber);
  }

  getReportPrintShipment(hubId?: number, empId?: number, typePrintId?: number, dateFrom?: any, dateTo?: any, searchText?: string, pageSize: number = null, pageNumber: number = null) {
    let params = new HttpParams();
    if (hubId)
      params = params.append("hubId", hubId + "");
    if (empId)
      params = params.append("empId", empId + "");
    if (typePrintId)
      params = params.append("typePrintId", typePrintId + "");
    if (dateFrom)
      params = params.append("dateFrom", dateFrom);
    if (dateTo)
      params = params.append("dateTo", dateTo);
    if (StringHelper.isNullOrEmpty(searchText)) {
      searchText = "";
    }
    params = params.append("searchText", searchText);
    return super.getCustomApiPaging("GetReportPrintShipment", [], params, pageSize, pageNumber);
  }

  async getReportPrintShipmentAsync(hubId?: number, empId?: number, typePrintId?: number, dateFrom?: any, dateTo?: any, searchText?: string, pageSize: number = null, pageNumber: number = null): Promise<ResponseModel> {
    const res = await this.getReportPrintShipment(hubId, empId, typePrintId, dateFrom, dateTo, searchText, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getHistoryPrintShipmentId(shipmentId: number, hubId?: number, empId?: number, typePrintId?: number, dateFrom?: any, dateTo?: any, pageSize: number = null, pageNumber: number = null) {
    let params = new HttpParams();
    if (shipmentId)
      params = params.append("shipmentId", shipmentId + "");
    if (hubId)
      params = params.append("hubId", hubId + "");
    if (empId)
      params = params.append("empId", empId + "");
    if (typePrintId)
      params = params.append("typePrintId", typePrintId + "");
    if (dateFrom)
      params = params.append("dateFrom", dateFrom);
    if (dateTo)
      params = params.append("dateTo", dateTo);
    return super.getCustomApiPaging("GetHistoryPrintShipmentId", [], params, pageSize, pageNumber);
  }

  async getHistoryPrintShipmentIdAsync(shipmentId: number, hubId?: number, empId?: number, typePrintId?: number, dateFrom?: any, dateTo?: any, pageSize: number = null, pageNumber: number = null): Promise<ResponseModel> {
    const res = await this.getHistoryPrintShipmentId(shipmentId, hubId, empId, typePrintId, dateFrom, dateTo, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getReportCancelShipment(model: any) {
    return super.postCustomApi("GetReportCancelShipment", model);
  }

  async getReportCancelShipmentAsync(model: any): Promise<ResponseModel> {
    const res = await this.getReportCancelShipment(model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getReportDebtPriceDetailByCustomer(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("customerId", customerId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    return super.getCustomApiPaging("getReportDebtPriceDetailByCustomer", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }

  async getReportDebtPriceDetailByCustomerAsync(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportDebtPriceDetailByCustomer(type, customerId, dateFrom, dateTo, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getReportDebtPriceDetailByCustomerDetailAsync(customerId: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number) {
    let params = new HttpParams();
    params = params.append("customerId", customerId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);

    const res = await super.getCustomApiPaging("GetReportDebtPriceDetailByCustomerDetail", [], params, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getReportDebtCODDetailByCustomer(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("customerId", customerId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    return super.getCustomApiPaging("getReportDebtCODDetailByCustomer", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }

  async getReportDebtCODDetailByCustomerDetailAsync(customerId: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("customerId", customerId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);

    const res = await super.getCustomApiPaging("GetReportDebtCODDetailByCustomerDetail", [], params, pageSize, pageNumber).toPromise() as ResponseOfReportModel;
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getReportDebtCODDetailByCustomerAsync(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportDebtCODDetailByCustomer(type, customerId, dateFrom, dateTo, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  getReportListGoodsPriceDetailByCustomer(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("customerId", customerId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    return super.getCustomApiPaging("GetReportListGoodsPriceDetailByCustomer", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }

  async getReportListGoodsPriceDetailByCustomerAsync(type?: number, customerId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportListGoodsPriceDetailByCustomer(type, customerId, dateFrom, dateTo, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getReportPickupDetail(userId: any = null, fromDate: any = null, toDate: any = null): Promise<ReportPickupDetail[]> {
    let params = new HttpParams();
    params = params.append("userId", userId);
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);

    const res = await this.getCustomApi("GetReportPickupDetail", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportDeliveryDetail(userId: any = null, fromDate: any = null, toDate: any = null): Promise<ReportDeliveryDetail[]> {
    let params = new HttpParams();
    params = params.append("userId", userId);
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);

    const res = await this.getCustomApi("GetReportDeliveryDetail", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportDeliveryFail(userId: any = null, fromDate: any = null, toDate: any = null): Promise<ReportDeliveryFail[]> {
    let params = new HttpParams();
    params = params.append("userId", userId);
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);

    const res = await this.getCustomApi("GetReportDeliveryFail", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportResultBusiness(dateFrom: any = null, dateTo: any = null, hubId: any = null, fromProvinceId: any = null, userId: any = null): Promise<ReportResultBusiness[]> {
    let params = new HttpParams();
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("hubId", hubId);
    params = params.append("fromProvinceId", fromProvinceId);
    params = params.append("userId", userId);

    const res = await this.getCustomApi("ReportResultBusiness", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportKPIBusiness(dateFrom: any = null, dateTo: any = null, hubId: any = null): Promise<ReportKPIBusiness[]> {
    let params = new HttpParams();
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("hubId", hubId);

    const res = await this.getCustomApi("ReportKPIBusiness", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportKPICustomer(dateFrom: any = null, dateTo: any = null, hubId: any = null, customerId: any = null): Promise<ReportKPICustomer[]> {
    let params = new HttpParams();
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("hubId", hubId);
    params = params.append("customerId", customerId);

    const res = await this.getCustomApi("ReportKPICustomer", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  //
  getReportShipmentQuantity(fromHubId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    return super.getCustomApiPaging("GetReportShipmentQuantity", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }
  async getReportShipmentQuantityAsync(fromHubId?: number, dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportShipmentQuantity(fromHubId, dateFrom, dateTo, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  //
  getReportComplain(dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number, salerId?: number, handleEmpId?: number, isCompensation?: boolean): Observable<ResponseOfReportModel> {
    let params = new HttpParams();

    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("salerId", salerId + "");
    params = params.append("handleEmpId", handleEmpId + "");
    params = params.append("isCompensation", isCompensation + "");
    return super.getCustomApiPaging("ReportComplain", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }
  async getReportComplainAsync(dateFrom?: any, dateTo?: any, pageSize?: number, pageNumber?: number, salerId?: number, handleEmpId?: number, isCompensation?: boolean): Promise<ResponseOfReportModel> {
    const res = await this.getReportComplain(dateFrom, dateTo, pageSize, pageNumber, salerId, handleEmpId, isCompensation).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  //
  getReportDiscountCustomer(dateFrom?: any, dateTo?: any, senderId?: number, salerId?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();

    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("senderId", senderId + "");
    params = params.append("salerId", salerId + "");
    return super.getCustomApi("ReportDiscountCustomer", params) as Observable<ResponseOfReportModel>;
  }
  async getReportDiscountCustomerAsync(dateFrom?: any, dateTo?: any, senderId?: number, salerId?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportDiscountCustomer(dateFrom, dateTo, senderId, salerId).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  //
  getReportPaymentPickupUser(dateFrom?: any, dateTo?: any, hubId?: any, userId?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("hubId", hubId + "");
    params = params.append("userId", userId + "");
    return super.getCustomApiPaging("ReportPaymentPickupUser", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }
  async getReportPaymentPickupUserAsync(dateFrom?: any, dateTo?: any, hubId?: any, userId?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportPaymentPickupUser(dateFrom, dateTo, hubId, userId, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  //
  getReportShipmentCOD(dateFrom?: any, dateTo?: any, isReturn?: boolean, toHubId?: any, empId?: any, pageSize?: number, pageNumber?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("fromDate", dateFrom);
    params = params.append("toDate", dateTo);
    params = params.append("isReturn", isReturn + "");
    params = params.append("toHubId", toHubId + "");
    params = params.append("empId", empId + "");
    return super.getCustomApiPaging("ReportShipmentCOD", [], params, pageSize, pageNumber) as Observable<ResponseOfReportModel>;
  }
  async getReportShipmentCODrAsync(dateFrom?: any, dateTo?: any, isReturn?: boolean, toHubId?: any, empId?: any, pageSize?: number, pageNumber?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportShipmentCOD(dateFrom, dateTo, isReturn, toHubId, empId, pageSize, pageNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  //
  getReportDeadline(dateFrom?: any, dateTo?: any, fromProvinceId?: number, toProvinceId?: number, fromHubId?: number, toHubId?: number, deliveryUserId?: number, senderId?: number, serviceId?: number, pageNumber?: number, pageSize?: number): Observable<ResponseOfReportModel> {
    let params = new HttpParams();
    params = params.append("fromDate", dateFrom);
    params = params.append("toDate", dateTo);
    params = params.append("fromProvinceId", fromProvinceId + "");
    params = params.append("toProvinceId", toProvinceId + "");
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("toHubId", toHubId + "");
    params = params.append("deliveryUserId", deliveryUserId + "");
    params = params.append("senderId", senderId + "");
    params = params.append("serviceId", serviceId + "");
    // params = params.append("pageNumber", pageNumber + "");
    // params = params.append("pageSize", pageSize + "");
    return super.getCustomApi("GetReportDeadline", params) as Observable<ResponseOfReportModel>;
  }
  async getReportDeadlineAsync(dateFrom?: any, dateTo?: any, fromProvinceId?: number, toProvinceId?: number, fromHubId?: number, toHubId?: number, deliveryUserId?: number, senderId?: number, pageNumber?: number, pageSize?: number): Promise<ResponseOfReportModel> {
    const res = await this.getReportDeadline(dateFrom, dateTo, fromProvinceId, toProvinceId, fromHubId, toHubId, deliveryUserId, senderId, pageNumber, pageSize).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getReportPrioritize(dateFrom?: any, dateTo?: any, fromProvinceId?: number, toProvinceId?: number, fromHubId?: number, toHubId?: number, deliveryUserId?: number, senderId?: number, pageNumber?: number, pageSize?: number) {
    let params = new HttpParams();
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("fromProvinceId", fromProvinceId + "");
    params = params.append("toProvinceId", toProvinceId + "");
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("toHubId", toHubId + "");
    params = params.append("deliveryUserId", deliveryUserId + "");
    params = params.append("senderId", senderId + "");
    return super.getCustomApiPaging("GetReportPrioritize", [], params, pageSize, pageNumber).toPromise();
  }

  async getReportLadingSchedule(model: ReportLadingScheduleFilter): Promise<ReportLadingSchedule[]> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("fromProvinceId", model.fromProvinceId);
    params = params.append("toProvinceId", model.toProvinceId);
    params = params.append("fromHubId", model.fromHubId);
    params = params.append("toHubId", model.toHubId);
    params = params.append("deliveryUserId", model.deliveryUserId);
    params = params.append("pageNumber", model.pageNumber);
    params = params.append("pageSize", model.pageSize);

    const res = await this.getCustomApi("ReportLadingSchedule", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportTruckTransfer(model: ReportTruckTransferFilter): Promise<ReportTruckTransfer[]> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("fromProvinceId", model.fromProvinceId);
    params = params.append("toProvinceId", model.toProvinceId);
    params = params.append("truckId", model.truckId);
    params = params.append("pageNumber", model.pageNumber);
    params = params.append("pageSize", model.pageSize);

    const res = await this.getCustomApi("ReportTruckTransfer", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportEmpReceiptIssue(model: ReportEmpReceiptIssueFilter): Promise<ReportEmpReceiptIssue[]> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("userId", model.userId);

    const res = await this.getCustomApi("ReportEmpReceiptIssue", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportIncidents(model: ReportIncidentsFilter): Promise<ReportIncidents[]> {
    let a = 1;
    let params = new HttpParams();
    params = params.append("dateFrom", model.fromDate);
    params = params.append("dateTo", model.toDate);
    params = params.append("customerId", model.customerId);
    params = params.append("handleEmpId", model.handleEmpId);
    params = params.append("incidentEmpId", model.incidentEmpId);
    params = params.append("isCompensation", model.isCompensation);
    params = params.append("pageNumber", model.pageNumber);
    params = params.append("pageSize", model.pageSize);

    const res = await this.getCustomApi("GetReportIncidents", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  //#region Dashboard
  async getDashboardShipment(model: DashboardFilter): Promise<DashboardShipment> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);

    let res = await this.getCustomApi("GetDashboardShipment", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getDashboardTransfer(model: DashboardFilter): Promise<DashboardTransfer> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);

    let res = await this.getCustomApi("GetDashboardTransfer", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getDashboardDelivery(model: DashboardFilter): Promise<DashboardDelivery> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);

    let res = await this.getCustomApi("GetDashboardDelivery", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async dashboardDebit(model: DashboardFilter): Promise<DashboardDebitModel> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);
    let res = await this.getCustomApi("GetDashboardDebit", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async getDashboardService(model: DashboardFilter): Promise<DashboardService> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);
    let res = await this.getCustomApi("GetDashboardService", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async getDashboardMonthlyRevenue(model: DashboardFilter): Promise<DashboardMonthlyRevenue[]> {
    let params = new HttpParams();
    params = params.append("year", model.year);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);

    let res = await this.getCustomApi("GetDashboardMonthlyRevenue", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data as DashboardMonthlyRevenue[];
  }

  async getDashboardPriceDebit(model: DashboardFilter): Promise<DashboardPriceDebit> {
    let params = new HttpParams();
    params = params.append("fromDate", model.fromDate);
    params = params.append("toDate", model.toDate);
    params = params.append("hubId", model.hubId);
    params = params.append("poHubId", model.poHubId);
    let res = await this.getCustomApi("GetDashboardPriceDebit", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  //#endregion

  async getReportListGoodsShipment(typeId?: number, createByHubId?: number, fromHubId?: number, toHubId?: number,
    userId?: number, statusId?: number, transportTypeId?: number, tplId?: number, senderId?: any, shipmentStatusId?: any, dateFrom?: any,
    dateTo?: any, searchText?: string, pageNumber: any = 1, pageSize: any = 20, listGoodsCode?: string): Promise<ListGoods[]> {
    let params = new HttpParams();
    params = params.append("typeId", typeId + "");
    params = params.append("createdByHubId", createByHubId + "");
    params = params.append("fromHubId", fromHubId + "");
    params = params.append("toHubId", toHubId + "");
    params = params.append("userId", userId + "");
    params = params.append("statusId", statusId + "");
    params = params.append("transportTypeId", transportTypeId + "");
    params = params.append("tplId", tplId + "");
    params = params.append("senderId", senderId + "");
    params = params.append("shipmentStatusId", shipmentStatusId + "");
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("listGoodsCode", listGoodsCode);
    params = params.append("searchText", searchText);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);

    let res = await super.getCustomApi("GetReportListGoodsShipment", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListGoods[];
    return data;
  }
  //
  async getReportByCus(model: ReportByCusFilter): Promise<ReportByCus[]> {
    let params = new HttpParams();
    params = params.append("dateFrom", model.dateFrom);
    params = params.append("dateTo", model.dateTo);
    params = params.append("senderId", model.senderId);
    if (model.listProvinceIds) params = params.append("listProvinceIds", model.listProvinceIds);
    if (model.listDeliveryIds) params = params.append("listDeliveryIds", model.listDeliveryIds);
    let res = await super.getCustomApi("getReportByCus", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ReportByCus[];
    return data;
  }
  async getReportRevenueMonth(model: ReportByCusFilter): Promise<ReportRevenueMonth[]> {
    let params = new HttpParams();
    params = params.append("dateFrom", model.dateFrom);
    params = params.append("dateTo", model.dateTo);
    if (model.fromHubIds) {
      params = params.append("fromHubIds", model.fromHubIds.join().toString());
    }
    if (model.toHubIds) {
      params = params.append("toHubIds", model.toHubIds.join().toString());
    }
    params = params.append("pageNumber", model.pageNumber);
    params = params.append("pageSize", model.pageSize);
    let res = await super.getCustomApi("GetReportByRevenueMonth", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ReportRevenueMonth[];
    return data;
  }

  async getReportRevenueYear(year: any): Promise<ReportRevenueYear[]> {
    let params = new HttpParams();
    params = params.append("year", year);
    let res = await super.getCustomApi("GetReportByRevenueYear", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ReportRevenueYear[];
    return data;
  }

  async getReportHandleEmployee(hubId?: any, userId?: any, isGroupEmp?: any, groupStatusId?: any,
    timeCompare?: any, dateFrom?: any, dateTo?: any, pageNumber?: any, pageSize?: any): Promise<ReportHanldeEmployee[]> {
    let params = new HttpParams();
    params = params.append("hubId", hubId);
    params = params.append("userId", userId);
    params = params.append("isGroupEmp", isGroupEmp);
    params = params.append("groupStatusId", groupStatusId);
    params = params.append("timeCompare", timeCompare);
    params = params.append("dateFrom", dateFrom);
    params = params.append("dateTo", dateTo);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    let res = await super.getCustomApi("GetReportHandleEmployee", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ReportHanldeEmployee[];
    return data;
  }

  async getCustomerLiabilitiesReport(customerId?: any, fromHubId?: any, dateFrom?: any,
    dateTo?: any, pageNumber?: any, pageSize?: any): Promise<Customer[]> {
    let params = new HttpParams();
    if (customerId) params = params.append("customerId", customerId);
    if (fromHubId) params = params.append("fromHubId", fromHubId);
    if (dateFrom) params = params.append("dateFrom", dateFrom);
    if (dateTo) params = params.append("dateTo", dateTo);
    if (pageNumber) params = params.append("pageNumber", pageNumber);
    if (pageSize) params = params.append("pageSize", pageSize);
    let res = await super.getCustomApi("GetCustomerLiabilitiesReport", params).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Customer[];
    return data;
  }

  async getListShipmentBoxLiabilitiesByCustomer(customerId?: any, fromHubId?: any, dateFrom?: any,
    dateTo?: any, pageNumber?: any, pageSize?: any): Promise<Shipment[]> {
    let params = new HttpParams();
    if (customerId) params = params.append("customerId", customerId);
    if (fromHubId) params = params.append("fromHubId", fromHubId);
    if (dateFrom) params = params.append("dateFrom", dateFrom);
    if (dateTo) params = params.append("dateTo", dateTo);
    if (pageNumber) params = params.append("pageNumber", pageNumber);
    if (pageSize) params = params.append("pageSize", pageSize);
    let res = await super.getCustomApi("GetListShipmentBoxLiabilitiesByCustomer", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async GetReportCustomerExport(filterViewModel?: ReportCustomerExport) {
    const res = await super.postCustomApiExcel("GetReportCustomerExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async GetReportPayablesAndReceivablesByCustomerExport(filterViewModel?: ReportPayablesAndReceivablesByCustomerViewModel) {
    const res = await super.postCustomApiExcel("GetReportPayablesAndReceivablesByCustomerExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async GetReportCancelShipmentExport(filterViewModel?: GetReportCancelShipmentExportViewModel) {
    const res = await super.postCustomApiExcel("GetReportCancelShipmentExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async ReportKPICustomerExport(filterViewModel?: ReportKPICustomerExport) {
    const res = await super.postCustomApiExcel("ReportKPICustomerExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async GetReportByRevenueMonthExport(filterViewModel?: GetReportByRevenueMonthViewModel) {
    const res = await super.postCustomApiExcel("GetReportByRevenueMonthExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async GetReportByRevenueYearExport(filterViewModel?: GetReportByRevenueYearViewModel) {
    const res = await super.postCustomApiExcel("GetReportByRevenueYearExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async reportCreateShipmentExport(filterViewModel?: GetReportPickupDeliveryExportViewModel) {
    const res = await super.postCustomApiExcel("ReportCreateShipmentExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  async getListShipmentCreatedByEmployeeIdExport(filterViewModel?: GetReportPickupDeliveryExportViewModel) {
    const res = await super.postCustomApiExcel("GetListShipmentCreatedByEmployeeIdExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async ReportTruckTransferExport(filterViewModel?: ReportTruckTransferFilter) {
    const res = await super.postCustomApiExcel("ReportTruckTransferExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async GetReportHandleEmployeeExport(filterViewModel?: ShipmentFilterViewModel) {
    const res = await super.postCustomApiExcel("GetReportHandleEmployeeExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }
  async getReportCustomerNoRevenueExport(model?: ReportCustomerExport) {
    const res = await super.postCustomApiExcel("GetReportCustomerNoRevenueExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }
  async getReportCustomerHaveRevenueExport(model?: ReportCustomerExport) {
    const res = await super.postCustomApiExcel("GetReportCustomerHaveRevenueExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }
  async getCustomerLiabilitiesReportExport(filterViewModel?: ReportCustomerLiabilities) {
    const res = await super.postCustomApiExcel("GetCustomerLiabilitiesReportExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  getReportDeliveryEmployee(model: ReportDeliveryEmployee): Observable<ResponseModel> {
    return super.postCustomApi("GetReportDeliveryEmployee", model);
  }

  async getReportDeliveryEmployeeAsync(model: ReportDeliveryEmployee): Promise<any[]> {
    const res = await this.getReportDeliveryEmployee(model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;

  }

  async getReportDeliveryEmployeeExport(filterViewModel?: ReportDeliveryEmployeeExport) {
    const res = await super.postCustomApiExcel("GetReportDeliveryEmployeeExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  async getReportDeliveryEmployeeDetailExport(filterViewModel?: ReportDeliveryEmployeeExport) {
    const res = await super.postCustomApiExcel("GetReportDeliveryEmployeeDetailExport", filterViewModel).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  async getListShipmentWaitAssignPickupExport(model: ShipmentWaitAssignPickupExport) {
    const res = await super.postCustomApiExcel("GetListShipmentWaitAssignPickupExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentVersionExport(model: ShipmentVersionExport) {
    const res = await super.postCustomApiExcel("GetListShipmentVersionExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListreportPromotionShipment(model: ReportPromotionShipmentFilter): Promise<ReportPromotionShipment[]> {
    const res = await super.postCustomApi("GetListreportPromotionShipment", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getPromotionShipmentExport(model: ReportPromotionShipmentExport) {
    const res = await super.postCustomApiExcel("GetPromotionShipmentExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentAccountant(model: ReportShipmentAccountantExport) {
    const res = await super.postCustomApiExcel("GetListShipmentAccountant", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async reportReceiveMoneyDeliveryEmployee(model: ReportDeliveryEmployee) {
    const res = await super.postCustomApi("ReportReceiveMoneyDeliveryEmployee", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async reportReceiveMoneyDeliveryEmployeeExport(model: ReportDeliveryEmployeeExport) {
    const res = await super.postCustomApiExcel("ReportReceiveMoneyDeliveryEmployeeExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListGoodsTranferLongExport(model: ListGoodsFilterViewModel) {
    const res = await super.postCustomApiExcel("GetListGoodsTranferLongExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getReportListGoodsTranferLongExport(model: ListGoodsFilterViewModel) {
    const res = await super.postCustomApiExcel("GetReportListGoodsTranferLongExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListGoodsTranferExport(model: ListGoodsFilterViewModel) {
    const res = await super.postCustomApiExcel("GetListGoodsTranferExport", model).toPromise();
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListOutWareHouseExport(model: ReportListOutWarehouse) {
    const res = await super.postCustomApiExcel("GetListOutWareHouseExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getReportShipmentsListGoodDeliveryExport(model: ReportShipmentListGoodDelivery) {
    const res = await super.postCustomApiExcel("GetReportShipmentsListGoodDeliveryExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentBoxByListGoodIdExport(model: ReportlistShipmentBoxByListGoodId) {
    const res = await super.postCustomApiExcel("GetListShipmentBoxByListGoodIdExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getShipmentUnloadReportExport(model: ReportlistShipmentBoxByListGoodId) {
    const res = await super.postCustomApiExcel("GetShipmentUnloadReportExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getReportListGoodsUnLoadExport(model: ListGoodTranferUnloadViewModel) {
    const res = await super.postCustomApiExcel("GetReportListGoodsUnLoadExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getReportShipmentContactExport(model: ShipmentContactFilter) {
    const res = await super.postCustomApiExcel("GetReportShipmentContactExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListPriceServiceExport(model: PriceServiceFilter) {
    const res = await super.postCustomApiExcel("GetListPriceServiceExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentContactExport(model: ShipmentContactFilter) {
    const res = await super.postCustomApiExcel("GetListShipmentContactExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentByShipmentContactIdExport(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApiExcel("GetListShipmentByShipmentContactIdExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListDeliveryPaymentEmployeeExport(model: DeliveryPaymentEmployee) {
    const res = await super.postCustomApiExcel("GetListDeliveryPaymentEmployeeExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentDeliveryInfoExport(model: DeliveryPaymentEmployee) {
    const res = await super.postCustomApiExcel("GetListShipmentDeliveryInfoExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getlistDeliveryInfoExport(model: DeliVeryInfoFilter) {
    const res = await super.postCustomApiExcel("GetlistDeliveryInfoExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentDeliveryInforIdExport(model: DeliVeryInfoFilter) {
    const res = await super.postCustomApiExcel("GetListShipmentDeliveryInforIdExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentHistoryDetailExport(model: ShipmentHistoryDetail) {
    const res = await super.postCustomApiExcel("GetListShipmentHistoryDetailExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListDebitExport(model: Debit) {
    const res = await super.postCustomApiExcel("GetListDebitExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListDebitContractExport(model: Debit) {
    const res = await super.postCustomApiExcel("GetListDebitContractExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getDebitDetailExport(model: ShipmentFilterViewModel) {
    const res = await super.postCustomApiExcel("GetDebitDetailExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListReceiptMoneyNewExport(model: ReceiptMoneyFromRiderExport) {
    const res = await super.postCustomApiExcel("GetListReceiptMoneyNewExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListTransactionHistory(model: TransactionHistoryFilter): Promise<any[]> {
    const res = await this.postCustomApi("GetListTransactionHistory", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;

  }

  async getListTransactionHistoryExport(model: TransactionHistoryFilter) {
    const res = await super.postCustomApiExcel("GetListTransactionHistoryExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getHandOverDetailExport(model: HandOverExport) {
    const res = await super.postCustomApiExcel("GetHandOverDetailExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getlistEmployeeCreateDeliveryInfo(model: any) {
    const res = await super.postCustomApi("GetlistEmployeeCreateDeliveryInfo", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getlistEmployeeCreateDeliveryInfoExport(model: any) {
    const res = await super.postCustomApiExcel("GetlistEmployeeCreateDeliveryInfoExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async GetListShipmentBoxLRMByEmpId(model: any): Promise<ResponseModel> {
    const res = await super.postCustomApi("GetListShipmentBoxLRMByEmpId", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async GetListShipmentBoxLRMByEmpIdExport(model: any) {
    const res = await super.postCustomApiExcel("GetListShipmentBoxLRMByEmpIdExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async reportShipmentToPartner(model: any) {
    const res = await super.postCustomApi("ReportShipmentToPartner", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async reportShipmentToPartnerExport(model: any) {
    const res = await super.postCustomApiExcel("ReportShipmentToPartnerExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getReportShipmentAwaitDelivery(model: any) {
    const res = await super.postCustomApi("GetReportShipmentAwaitDelivery", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportShipmentAwaitDeliveryExport(model: any) {
    const res = await super.postCustomApiExcel("GetReportShipmentAwaitDeliveryExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }
  async getReportListShipmentNotTranfer(model: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetReportListShipmentNotTranferExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListIncidentsExport(model: IncidentFillter): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetListIncidentsExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentPaymentShortDebitExport(model: ReportPaymentDebitExport): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetListShipmentPaymentShortDebitExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentToPaymentContractExport(model: ReportPaymentDebitExport): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetListShipmentToPaymentContractExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentPaymentLongDebitExport(model: ReportPaymentDebitExport): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetListShipmentPaymentLongDebitExcel", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  downLoadFile(data: any, type: string, fileName: string) {
    if (!fileName) fileName = "EXPORT_BAO_CAO";
    var a = document.createElement("a");
    document.body.appendChild(a);
    //
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    //
  }
  async getReportSMSZalo(model: ReportZaloFilter): Promise<any[]> {
    let res = await super.postCustomApi("ReportSMSZalo", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getReportSMSZaloExport(model: ReportZaloFilter): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("ReportSMSZaloExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getListShipmentExport(filterViewModel?: ShipmentFilterViewModel): Promise<ResponseModel> {
    const res = await super.postCustomApiExcel("GetListShipmentExport", filterViewModel).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", filterViewModel.customExportFile.fileNameReport);
  }

  async getListInvoiceCustomerExport(model: InvoiceCustomerFilter) {
    const res = await super.postCustomApiExcel("getListInvoiceCustomerExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }

  async getShipmentTransferOverlap(model: any): Promise<ResponseModel> {
    let res = await super.postCustomApi("getShipmentTransferOverlap", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getShipmentTransferOverlapExport(model: ListGoodTranferUnloadViewModel) {
    const res = await super.postCustomApiExcel("getShipmentTransferOverlapExport", model).toPromise();
    if (res.message) return;
    this.downLoadFile(res, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", model.customExportFile.fileNameReport);
  }
}
